var CloseTarget = /*#__PURE__*/function (CloseTarget) {
  CloseTarget["Overlay"] = "overlay";
  CloseTarget["CloseIcon"] = "close-icon";
  CloseTarget["EscapeButton"] = "escape-button";
  CloseTarget["ActionButton"] = "action-button";
  CloseTarget["SwipeDown"] = "swipe-down";
  return CloseTarget;
}({});

export { CloseTarget };
//# sourceMappingURL=portal.js.map
